import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root'})
export class PaginatorService {
    private pageSizeOptions = [50, 100, 250];
    
    public getPageSizeOptions = (): number[] => this.pageSizeOptions;
    public getItemsPerPageDefault = (): number => this.pageSizeOptions[0];
}
